export default "__VITE_ASSET__CwNz9PLw__"